import styled from 'styled-components';

export const StyledDivider = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 1px;
    background-color: var(--cl-background-secondary-hovered);
  }
`;

export const StyledDividerText = styled.span`
  position: relative;
  font-size: 16px;
  padding: 5px 12px;
  background: white;
  color: black;
`;

